/**
 * @desc Summerops layers to import into the store
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

import callouts from "./callouts";
import fireboxes from "./fireboxes";

export default {
  modules: {
    callouts,
    fireboxes
  }
};
